var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer disabled-print"},[_c('footer',[_vm._v("Copyright © 2026 All Rights Reserved")])])
}]

export { render, staticRenderFns }